import { faCheck, faCheckDouble, faWarning } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Autocomplete, Box, Chip, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { RecursivePartial, XOR } from "types/custom"
import { Batch } from "types/graphql"

interface BatchSelectProps {
  value: XOR<RecursivePartial<Batch>, RecursivePartial<Batch>[]>
  batches: RecursivePartial<Batch>[]
  onChange(value: XOR<RecursivePartial<Batch>, RecursivePartial<Batch>[]>): any
  className: string
  label?: string
  limitTags?: number
  showAIRequestsCount?: boolean
}

const DEFAULT_LIMIT_TAGS = 1;
const BatchSelect = (props: BatchSelectProps) => {
  const { t } = useTranslation()
  const _limitTags = props.limitTags || DEFAULT_LIMIT_TAGS;
  const _showAIRequestsCount = props.showAIRequestsCount;
  return (
    <FormControl className={props.className} >
      <Autocomplete
        key={props.value?.id}
        disableClearable
        autoHighlight
        multiple={Array.isArray(props.value)}
        onChange={(event, batch) => { props.onChange(batch) }}
        options={props.batches}
        getOptionLabel={option => option.name}
        isOptionEqualToValue={(option, value) => option?.id == value?.id}
        // defaultValue={props.batches.find(batch => batch.id == props.value?.id)}
        value={props.value}
        // defaultValue={props.defaultValue || ""}
        className="w-full"
        size="small"
        style={{ minWidth: "10em" }}
        renderInput={(params) =>
          <TextField
            {...params}
            label={t(props.label || "labels.batch")}
            InputProps={{
              ...params.InputProps,
              // type: 'search',
            }}
          />
        }

        renderOption={(props, batch) => (
          <Box component="li" {...props}>
            <div className="flex justify-between items-start w-full leading-none">
              <div>
                <Typography className="mb-0">{batch.name}</Typography>
                {batch.quantity && <Typography variant="caption">{batch.quantity} {batch.batchInitial?.stadePL && `PL${batch.batchInitial.stadePL}`}</Typography>}
              </div>
              {_showAIRequestsCount && batch.aiRequestsCount > 0 && <div className="bg-blue-500 w-4 h-4 text-center text-white text-xs rounded-full">{batch.aiRequestsCount}</div>}
              <div className="flex gap-2">
                {batch.report?.id && !batch.harvest?.id && <FontAwesomeIcon icon={faWarning} className="text-orange-600 mt-1" />}
                {batch.report?.id && batch.harvest?.id && <FontAwesomeIcon icon={faCheckDouble} className={`${batch.isStopped ? "text-orange-600" : "text-green-600"} mt-1`} />}
                {!batch.report?.id && batch.harvest?.id && <FontAwesomeIcon icon={faCheck} className={`${batch.isStopped ? "text-orange-600" : "text-blue-500"} mt-1`} />}
              </div>
            </div>
          </Box>
        )}
        renderTags={(value, getTagProps) => {
          const numTags = value.length;

          return (
            <>
              {value.slice(0, _limitTags).map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={index}
                  label={option.name}
                  size="small"
                />
              ))}

              <Typography variant="caption" className="ml-1">{numTags > _limitTags && ` +${numTags - _limitTags}`}</Typography>
            </>
          );
        }}
      />
    </FormControl>
  )
}

export default BatchSelect
